import { constants } from 'os';

const config = {
  VERSION: process.env.VERSION
};

export default config;
export const pageSize = 20;

export const SERVER_API_URL = process.env.SERVER_API_URL + '/user-portal/';

export const AUTHORITIES = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
  MANAGER: 'ROLE_MANAGER'
};
export const AUTHORIZE_SMART_CA = {
  scope: 'sign offline_access',
  code: 'code'
};
export const LINK_TERM_OF_USE = 'https://dichvucong.gov.vn/p/home/dvc-dieu-khoan-su-dung.html';
export const LINK_TERM_OF_USE_SMART_ID = 'https://test.dichvucong.gov.vn/p/home/dvc-huong-dan-su-dung-smartid.html';

export const KEY_STORAGE = {
  ARRAY_PROVINCE: 'array_province',
  DATA_INPUT_BIRTHPLACE: 'data_birthPlace',
  USER_IDENTITY_SMART_ID: 'USER_IDENTITY_SMART_ID',
  RESULT_SMART_ID: 'RESULT_SMART_ID',
  USER_TYPE: 'USER_TYPE',
  UPDATE_DATA_RESIDENTIAL: 'CSDL Quốc gia về Dân cư'
};

export const ACR_VALUES = {
  LOA2: 'LOA2', // login method sms
  LOA3: 'LOA3' // login method usb or sim PKI
};

export const messages = {
  DATA_ERROR_ALERT: 'Internal Error'
};

export const APP_DATE_FORMAT = 'DD/MM/YYYY HH:mm';
export const APP_TIMESTAMP_FORMAT = 'DD/MM/YY HH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'DD/MM/YYYY';
export const APP_LOCAL_DATE_FORMAT_YYYYMMDD = 'YYYYMMDD';
export const APP_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const APP_LOCAL_DATETIME_FORMAT_Z = 'YYYY-MM-DDTHH:mm Z';
export const APP_WHOLE_NUMBER_FORMAT = '0,0';
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = '0,0.[00]';

export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const CHANGE_PHONE = 'ChangePhone';
export const IND = '1';
export const ENP = '2';
export const ORG = '3';
export const MALE = '1';
export const FEMALE = '2';
export const NUMBER_OTP_FAIL = 5;
export const LIST_PATHNAME = ['/userprofile', '/login/eid/code'];
export const KEY_LOGIN = 'keylogin';

export const claim = {
  FULL_NAME: 'fullName',
  BIRDTHDAY: 'dob',
  GENDER: 'gender',
  IDENTITY: 'identity',
  ADDRESS: 'address'
};

export const Authenticator_Type = {
  PASSWORD: 'PASSWORD',
  SMS: 'SMS',
  EMAIL: 'EMAIL',
  USB: 'USB',
  PKI: 'PKI',
  SMART_CA: 'SMART_CA',
  TOTP: 'TOTP'
};

export const MSSP_PROVIDER = {
  VINA: 'METHICS',
  VIETTEL: 'VIETTEL',
  BCY: 'GOV',
  MOBI: 'mobifone'
};

export const Home_Network = {
  VINA: 'VINA',
  VIETTEL: 'VIETTEL',
  MOBI: 'MOBI'
};

export const Rester_Type = {
  THUE_BAO_DI_DONG: 'THUE_BAO_DI_DONG',
  BAO_HIEM_XA_HOI: 'BAO_HIEM_XA_HOI',
  THUE: 'THUE',
  USB_KY_SO: 'USB_KY_SO',
  SIM_KY_SO: 'SIM_KY_SO',
  SMART_ID: 'SMART_ID',
  EMAIL: 'EMAIL',
  MOBILE: 'SMS'
};

export const REGISTER_FACE_ID = false;

export const Authenticator_Status = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

//=============Admin Search ===============//

export const Method_Register = {
  0: 'Tất cả hình thức',
  1: 'Thuê bao di động',
  2: 'USB ký số',
  3: 'Sim ký số',
  4: 'Bảo hiểm xã hội',
  5: 'Bưu điện Việt Nam'
};

export const Authentication_Level = {
  0: 'Tất cả mức xác minh',
  1: 'Mức 2',
  2: 'Mức 3'
};

export const Data_Resources = {
  0: 'Tất cả nguồn dữ liệu',
  1: 'Công dân tự đăng ký',
  2: 'Dữ liệu tạo theo công văn'
};

export const Approved_Status = {
  0: 'Không có trạng thái',
  1: 'Đã xử lý',
  2: 'Chờ xử lý'
};

export const Gender = {
  0: 'Tất cả',
  1: 'Nam',
  2: 'Nữ'
};

export const Active_Status = {
  0: 'Tất cả trạng thái',
  1: 'Đang hoạt động',
  2: 'Ngưng hoạt động'
};

//=============Admin Search ===============//
export const ADD = {
  PROVINCE: 'stateAddress',
  DISTRICT: 'districtAddress',
  COMMUNE: 'wardAddress',
  ADDRESS: 'streetAddress'
};
// export const CURRENT_ADDRESS = {
//   PROVINCE: 'stateCurrentAddress',
//   DISTRICT: 'districtCurrentAddress',
//   COMMUNE: 'wardCurrentAddress',
//   ADDRESS: 'streetCurrentAddress'
// };
export const BORN_PLACE = {
  PROVINCE: 'stateBirthPlace',
  DISTRICT: 'districtBirthPlace',
  COMMUNE: 'wardBirthPlace',
  ADDRESS: 'streetBirthPlace'
};

export const NATIVE_VILLAGE = {
  PROVINCE: 'stateHomeTown',
  DISTRICT: 'districtHomeTown',
  COMMUNE: 'wardHomeTown',
  ADDRESS: 'streetHomeTown'
};

export const RESIDENT = {
  PROVINCE: 'statePermanentAddress',
  DISTRICT: 'districtPermanentAddress',
  COMMUNE: 'wardPermanentAddress',
  ADDRESS: 'streetPermanentAddress'
};

export const DEFAULT_PROVINCE = '--Chọn Tỉnh/ Thành Phố--';
export const DEFAULT_DISTRICT = '--Chọn Quận/ Huyện--';
export const DEFAULT_WARD = '--Chọn Phường/ Xã--';

export const LEVEL = {
  1: 'Mức 2',
  2: 'Mức 3'
};
export const Resources = [
  { key: '1', value: 'CSDL nhà mạng' },
  { key: '2', value: 'CSDL BHXH' },
  { key: '3', value: 'CSDL thuế' },
  { key: '4', value: 'Bộ KHĐT' },
  { key: '5', value: 'Ban Cơ Yếu' },
  { key: '6', value: 'Tệp đính kèm chứng thực điện tử' },
  { key: '7', value: 'CSDL Quốc gia về Dân cư' },
  { key: '8', value: 'Chia sẻ CSDL Quốc gia về Dân cư' }
];
export const ACCOUNT = {
  ACTIVE: 1,
  INACTIVE: 0
};

export const BUILD_MODE = {
  REG: 'reg',
  ADMIN: 'admin',
  BOTH: 'both'
};

export const oauth2 = {
  CLIENT_ID: 'urK53IWOwwH44_LnszTJoHlDVhMa', //local
  URL_CALLBACK: 'https://xacthuc.mae.gov.vn/user-portal',
  SCOPE: 'openid',
  URL: 'https://xacthuc.mae.gov.vn/oauth2/authorize?response_type=code&client_id=',
  //URL_DICHVUCONG: 'https://dichvucong.gov.vn/p/home/dvc-trang-chu.html',
  URL_DICHVUCONG:
    'https://xacthuc.mae.gov.vn/oauth2/authorize?response_type=code&client_id=Np0ahpF4exnI6DS_4KuMK_TLHLEa&scope=openid&redirect_uri=https://dichvucong.gov.vn/p/home/dvc-trang-chu.html',
  DEEP_LINK_MOBILE: 'eCitizenID://oauth',
  HOSTNAME_REGISTER: 'xacthuc.mae.gov.vn/user-portal'
};

export const plugin = {
  vnpt:
    'https://dichvucong.gov.vn/jsp/dvc-common/download-public.jsp?type=public&filenameOrigin=VNPT-CA%20Plugin_Office_Setup_1.0.1.9.exe&filename=VNPT-CA%20Plugin_Office_Setup_1.0.1.9.exe',
  vnpt_mac:
    'https://dichvucong.gov.vn/jsp/dvc-common/download-public.jsp?type=public&filenameOrigin=VNPT_Products_Plugin_ky_so_MAC_OS_1.0.0.9.pkg&filename=VNPT_Products_Plugin_ky_so_MAC_OS_1.0.0.9.pkg'
};

export const download_plugin = {
  vnpt: 'https://dichvucong.gov.vn/p/home/phan-mem-ho-tro.html'
};

export const LINK_INTRODUCE_SMART_CA = 'https://smartca.vnpt.vn';

export const PLUGIN = {
  WINDOWS_OS: 'https://xacthuc.mae.gov.vn/user-portal/statics/plugin/VGCASignServiceSetup.msi',
  MAC_OS: 'https://xacthuc.mae.gov.vn/user-portal/statics/plugin/VGCA_VCTKInstaller.pkg'
};

export const STATUS_TYPES = {
  REGISTER: {
    PENDING_APPROVAL: 'Chờ phê duyệt',
    PENDING_ACCOUNT_ISSUANCE: 'Chờ cấp tài khoản',
    APPROVED: 'Đã phê duyệt',
    REJECT: 'Đã từ chối',
    ACCOUNT_ISSUANCE_REJECT: 'Từ chối cấp tài khoản'
  },
  IMPLEMENT: {
    PENDING_APPROVAL: 'Chờ phê duyệt',
    APPROVED: 'Đã phê duyệt',
    REJECT: 'Đã từ chối'
  },
  ACCOUNT: {
    ACTIVATED: 'Đang hoạt động',
    INACTIVE: 'Ngưng hoạt động'
  },
  DELETE_ACCOUNT: {
    APPROVED: 'Đã xóa'
  },
  CANCEL_ACCOUNT: {
    PENDING_APPROVAL: 'Chờ duyệt',
    APPROVED: 'Đã duyệt',
    REJECT: 'Đã từ chối'
  },
  LINK_ACCOUNT: {
    NOT_YET_BOUND: 'Chưa liên kết',
    PENDING: 'Chờ liên kết',
    APPROVED: 'Đã liên kết'
  }
};

export const ACTION_BUTTONS = {
  REGISTER: {
    PENDING_APPROVAL: ['Xem', 'Duyệt', 'Từ chối'],
    PENDING_ACCOUNT_ISSUANCE: ['Xem', 'Cấp tài khoản', 'Hủy duyệt'],
    APPROVED: ['Xem'],
    REJECT: ['Xem'],
    ACCOUNT_ISSUANCE_REJECT: ['Xem']
  },
  IMPLEMENT: {
    PENDING_APPROVAL: ['Xem', 'Phê duyệt', 'Từ chối'],
    APPROVED: ['Xem'],
    REJECT: ['Xem']
  },
  ACCOUNT: {
    ACTIVATED: ['Xem', 'Ngưng hoạt động'],
    INACTIVE: ['Xem', 'Mở hoạt động']
  },
  DELETE_ACCOUNT: {
    APPROVED: ['Xem', 'Xem lịch sử']
  },
  CANCEL_ACCOUNT: {
    PENDING_APPROVAL: ['Xem', 'Phê duyệt', 'Từ chối'],
    APPROVED: ['Xem'],
    REJECT: ['Xem']
  },
  LINK_ACCOUNT: {
    NOT_YET_BOUND: ['Xem', 'Liên kết'],
    PENDING: ['Xem'],
    APPROVED: ['Xem']
  }
};

export const actionImageMap = {
  Xem: require('app/images/eye.png'),
  Duyệt: require('app/images/coolicon.png'),
  'Phê duyệt': require('app/images/coolicon.png'),
  'Từ chối': require('app/images/X.png'),
  'Cấp tài khoản': require('app/images/coolicon.png'),
  'Hủy duyệt': require('app/images/X.png'),
  'Ngưng hoạt động': require('app/images/switch-on.png'),
  'Mở hoạt động': require('app/images/switch-off.png'),
  'Xóa tài khoản': require('app/images/delete.png'),
  'Xem lịch sử': require('app/images/list.png'),
  'Liên kết': require('app/images/timeline.png')
};

export const MESSAGE = {
  OTP: 'la ma xac thuc (OTP). Ma co hieu luc trong vong 2 phut.'
};
